import { UsersApi } from "@/api/users";
import { SetUserStatusRequest } from "@/api/users/types";
import { ResourceName } from "@/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotify } from "react-admin";

export const useSetUserStatus = ({ closeMenu }: { closeMenu: () => void }) => {
  const queryClient = useQueryClient();
  const notify = useNotify();

  const { mutate: setUserStatus } = useMutation({
    mutationFn: (body: SetUserStatusRequest) => UsersApi.setUserStatus(body),
    onMutate: () => {
      closeMenu();
    },
    onError: (error) => {
      notify(error, { type: "error" });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ResourceName.USERS],
      });
      notify("User status updated!", { type: "success" });
    },
  });

  return {
    setUserStatus,
  };
};
